import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagesRoutingModule } from './pages-routing.module';
import { SkeletonWidgetModule } from '@box-skeleton-widget/skeleton-widget.module';
import { SharedModule } from '@box-shared/shared.module';

import * as Components from './components';
import * as Pages from './pages';

@NgModule({
  declarations: [
    Components.LandingChainComponent,
    Components.LandingChainsComponent,
    Components.LandingCuisinesComponent,
    Components.LandingLocationsComponent,
    Components.LandingMerchantsComponent,
    Components.LandingEarnComponent,
    Components.LandingEarnDialogComponent,
    Components.LandingHeroComponent,
    Components.LandingHeroLocationComponent,
    Components.LandingPromoBannerComponent,
    Components.LandingHeroWordsComponent,
    Pages.LandingPage,
    Pages.BlastPage
  ],
  imports: [CommonModule, PagesRoutingModule, SharedModule, SkeletonWidgetModule],
  exports: [],
  providers: []
})
export class PagesModule {}
